import { useNotifications } from '@shared/notifications/model/useNotifications';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
export const useGetNotifications = (): JSX.Element[] => {
  const {
    notifications
  } = useNotifications();
  const notificationsJSX: JSX.Element[] = [];
  notifications.forEach(({
    uid,
    type,
    title,
    message,
    close
  }) => {
    notificationsJSX.push(<Snackbar sx={{
      position: 'relative'
    }} autoHideDuration={5000} key={uid} onClose={event => {
      // ignore click outside
      if (event?.type !== 'click') {
        close(event);
      }
    }} open>
        <Alert severity={type} onClose={close}>
          {title && <AlertTitle>{title}</AlertTitle>}
          {message}
        </Alert>
      </Snackbar>);
  });
  return notificationsJSX;
};